import type { Color } from "../../types";
import type { HasAverageColor } from "../HasAverageColor";
import type { HasBackgroundColor } from "../HasBackgroundColor";
import type { VirtualViewportPixelAccessor } from "../VirtualViewportPixelAccessor";
import { AbstractVirtualPixelDecorator } from "./AbstractVirtualPixelDecorator";

/**
 * VerticalTileEdge virtual pixel decorator.
 */
export class VerticalTileEdgeVirtualPixel<
  DecoratedType extends VirtualViewportPixelAccessor &
    HasAverageColor &
    HasBackgroundColor
> extends AbstractVirtualPixelDecorator<DecoratedType> {
  /**
   * @inheritDoc
   */
  getVirtualPixelColor(x: number, y: number): Color {
    if (x < 0 || x >= this.width) {
      return this.decorated.getPixelColor(
        Math.max(0, Math.min(this.width - 1, x)),
        Math.max(0, Math.min(this.height - 1, y))
      );
    }
    const rx = x % this.width;
    const ry = y % this.height;

    return this.decorated.getPixelColor(
      rx < 0 ? this.width + rx : rx,
      ry < 0 ? this.height + ry : ry
    );
  }
}
